// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationPriceDropPath = 'M90.338 6.31a16.67 16.67 0 00-17.022.053h-25.22a10.508 10.508 0 00-8.252 4.05L1 59.696l47.07 37.083 18.166-23.081L86.913 47.49a10.498 10.498 0 001.963-8.997L82.3 11.009a9.67 9.67 0 019.238 9.927l6.997.193.007-.363a16.67 16.67 0 00-8.203-14.455zm-23.45 7.053a16.655 16.655 0 00-1.68 7.766l.004.385c.026.99.144 1.975.352 2.943l6.844-1.468-.074-.385a9.102 9.102 0 01-.128-1.557l-.005-.43a9.671 9.671 0 013.336-7.254h.128l6.407 26.774a3.508 3.508 0 01-.651 3.015L60.738 69.365l-13.837 17.58L10.83 58.53l34.524-43.8a3.51 3.51 0 012.758-1.367h18.775zM46 52.35l-6.614-5.794-4.612 5.266 14.647 12.83 14.856-13.02-4.614-5.265L53 52.208V34h-7v18.35z';
var IllustrationPriceDrop = baseIllustration('IllustrationPriceDrop', {
  getPath: () => IllustrationPriceDropPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationPriceDrop;
//# sourceMappingURL=index.js.map